import React from 'react';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube } from 'react-icons/fa';
import './TopBar.css';

const TopBar = () => {
  return (
    <div className="top-bar">
      <div className="social-links">
        <a href="https://www.facebook.com/Neuroverseai" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
        <a href="https://www.instagram.com/neuroverseai1" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
        <a href="https://www.youtube.com/@Neuroverseai68" target="_blank" rel="noopener noreferrer"><FaYoutube /></a> {/* Placeholder Link */}
        <a href="https://www.linkedin.com/company/neuroverseai-official/?viewAsMember=true" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
      </div>
    </div>
  );
};

export default TopBar;
